export enum apiUrlNotificationList {
    NOTIFICATION_LIST = '/v1/notifications/my/',
    NOTIFICATION_COUNT = '/v1/notifications/count/',
}
